import React from 'react'

const Products = ({ shipment }) => {
    if (shipment) {
        let products = []


        shipment.handlingUnits.forEach(hu => {
            hu.items.forEach(item => {
                products.push(item.description)
            })
        })

        let uniqueProducts = [...new Set(products)]
        
        return (
            <div>
                {uniqueProducts.map((product, index) => <div key={index}>{product}</div>)}
            </div >
        )
    } else {
        return null
    }

}

export default Products